export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7999.3130bc6a.jpg";